import type ExcelJS from 'exceljs'

const DATE_LIKE_PATTERN = /^\s*\d{1,2}\/\d{1,2}\/\d{2,4}(\s.*)?$/

const isDateLikeString = (value: unknown): value is string =>
    typeof value === 'string' && DATE_LIKE_PATTERN.test(value)

const applyToCell = (cell: ExcelJS.Cell) => {
    if (isDateLikeString(cell.value)) {
        cell.numFmt = '@'
    }
}

export const forceTextOnDateCells = (
    target: ExcelJS.Workbook | ExcelJS.Worksheet | ExcelJS.Row,
) => {
    const anyTarget = target as any
    if (typeof anyTarget.eachSheet === 'function') {
        anyTarget.eachSheet((sheet: ExcelJS.Worksheet) =>
            sheet.eachRow((row) => row.eachCell(applyToCell)),
        )
    } else if (typeof anyTarget.eachRow === 'function') {
        anyTarget.eachRow((row: ExcelJS.Row) => row.eachCell(applyToCell))
    } else if (typeof anyTarget.eachCell === 'function') {
        anyTarget.eachCell(applyToCell)
    }
}

export const forceTextOnDateCellsXlsx = (worksheet: any) => {
    if (!worksheet || typeof worksheet !== 'object') return
    for (const key of Object.keys(worksheet)) {
        if (key.startsWith('!')) continue
        const cell = worksheet[key]
        if (!cell || typeof cell !== 'object') continue
        if (isDateLikeString(cell.v)) {
            cell.t = 's'
            cell.z = '@'
        }
    }
}
